<app-walk-tile
  *ngIf="isWalk(item)"
  [item]="asWalk(item)"
  class="tile tile--clickable"
  data-controller="generic/ui/ClickableTile"
></app-walk-tile>
<app-deal-tile
  *ngIf="isDeal(item)"
  [item]="asDeal(item)"
  class="tile tile--clickable"
  data-controller="generic/ui/ClickableTile"
></app-deal-tile>
